/**
 * Created by andrey on 06.09.2021.
 */

const UnitsShop = function () {
    this.tabs = {};

    for (const tab in UnitsShop.PRODUCTS) {
        this.tabs[tab] = new UnitsShopTab(cleverapps.castType(tab));
    }

    this.load();
};

UnitsShop.prototype.isAvailable = function () {
    return cleverapps.user.checkAvailable(cleverapps.config.availables.UNITS_SHOP);
};

UnitsShop.prototype.getAvailableShops = function () {
    const pageId = cleverapps.meta.selectedLocationId();

    const shops = UnitsShop.SHOPS[pageId];

    if (!shops) {
        return [];
    }

    const isVip = cleverapps.vipAdsAdapter.getVIPStatus().status;

    return shops.filter((shop) => {
        if (shop.unit && !cleverapps.unitsLibrary.isOpened(shop.unit)) {
            return false;
        }

        if (shop.level && cleverapps.user.currentPhysicalLevel.level < shop.level) {
            return false;
        }

        if ([ShopWindow.TABS.UNITS_ADS, ShopWindow.TABS.UNITS_ADS_VIP].includes(shop.tab)) {
            if (!connector.ads.isRewardedSupported) {
                return false;
            }

            if (isVip) {
                return shop.tab === ShopWindow.TABS.UNITS_ADS_VIP;
            }

            return shop.tab === ShopWindow.TABS.UNITS_ADS;
        }

        return true;
    });
};

UnitsShop.prototype.reset = function () {
    this.load({});
    this.save();
};

UnitsShop.prototype.load = function (stored) {
    stored = stored || cleverapps.dataLoader.load(DataLoader.TYPES.UNITS_SHOP) || {};
    let needSave = false;
    for (const id in stored) {
        if (stored[id] && UnitsShop.PRODUCTS[id] === undefined) {
            stored[id] = undefined;
            needSave = true;
        }
    }

    for (const id in this.tabs) {
        this.tabs[id].load(stored[id] || {});
    }

    if (needSave) {
        this.save();
    }
};

UnitsShop.prototype.save = function (fromServer) {
    cleverapps.dataLoader.save(DataLoader.TYPES.UNITS_SHOP, this.getInfo());

    if (!fromServer) {
        connector.synchronizer.addSendTask("unitsshop");
    }
};

UnitsShop.prototype.getInfo = function () {
    const info = {};
    for (const id in this.tabs) {
        info[id] = this.tabs[id].save();
    }
    return info;
};

UnitsShop.prototype.updateInfo = function (serverData) {
    this.load(serverData || {});
    this.save(true);
};

UnitsShop.prototype.stopRefreshTimeouts = function () {
    for (const id in this.tabs) {
        this.tabs[id].clear();
    }
};

UnitsShop.prototype.runRefreshTimeouts = function () {
    for (const id in this.tabs) {
        this.tabs[id].runRefreshTimeout();
    }
};

UnitsShop.SHOPS = {
    main: [{
        tab: ShopWindow.TABS.UNITS_FRUIT,
        unit: { code: "discountshop", stage: 0 },
        icon: bundles.tile_shop.frames.tab_fruitshop
    }, {
        tab: ShopWindow.TABS.UNITS_RESOURCE,
        unit: { code: "discountshop", stage: 0 },
        icon: bundles.tile_shop.frames.tab_resourceshop
    }, {
        tab: ShopWindow.TABS.UNITS_DISCOUNT,
        unit: { code: "discountshop", stage: 0 },
        icon: bundles.tile_shop.frames.tab_discountshop
    }, {
        tab: ShopWindow.TABS.UNITS_ADS,
        icon: bundles.tile_shop.frames.tab_cinema,
        level: 7
    }, {
        tab: ShopWindow.TABS.UNITS_ADS_VIP,
        icon: bundles.tile_shop.frames.tab_cinema,
        level: 7
    }]
};